import React from 'react'
import styled, { css } from 'styled-components'

const Center = styled.div`
  display: flex;
  width: 100%;
`

const containerStyles = {
  default: css`
    width: 100%;
    max-width: 48rem;
    p {
      :last-of-type {
        margin-bottom: 0;
      }
    }
  `,
  sm: css`
    max-width: 40rem;
  `,
  md: css`
    max-width: 56rem;
  `,
  lg: css`
    max-width: 80rem;
  `,
  xl: css`
    max-width: 116rem;
  `,
}

const StyledContainer = styled.div`
  ${containerStyles.default};
  ${props => containerStyles[props.wMax]};
  position: relative;
`

const LeftSpacer = styled.div`
  flex-grow: 1;
`

const RightSpacer = styled.div`
  background: ${props => props.splitBackground};
  flex-grow: 1;
`

const SplitContainer = styled.div`
  ${containerStyles.default};
  ${props => containerStyles[props.wMax]};
  background: ${props => props.splitBackground};
  display: grid;
  grid-template-columns: ${props => props.splitRatio || '10fr 7fr'};
`

const LeftContainer = styled.div`
  background: ${props => props.background};
`

const RightContainer = styled.div`
  background: ${props => props.splitBackground};
  color: ${props => props.splitColor};
`

const Container = props => (
  <>
    <Center className={props.className}>
      <LeftSpacer />
      {props.splitBackground ? (
        <SplitContainer
          wMax={props.wMax}
          splitRatio={props.splitRatio}
          splitBackground={props.splitBackground}
        >
          <LeftContainer background={props.background}>
            {props.contentLeft}
          </LeftContainer>
          <RightContainer
            splitColor={props.splitColor}
            splitBackground={props.splitBackground}
          >
            {props.contentRight}
          </RightContainer>
          {props.children}
        </SplitContainer>
      ) : (
        <StyledContainer wMax={props.wMax}>{props.children}</StyledContainer>
      )}
      <RightSpacer splitBackground={props.splitBackground} />
    </Center>
  </>
)

export default Container
